// src/components/email/EmailHtmlViewer.tsx
import React from "react";
import DOMPurify from "dompurify";

interface EmailHtmlViewerProps {
  htmlContent: string;
}

const EmailHtmlViewer: React.FC<EmailHtmlViewerProps> = ({ htmlContent }) => {
  const sanitizedHtml = DOMPurify.sanitize(htmlContent);
  return (
    <div
      style={{ overflow: "auto" }}
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
    />
  );
};

export default EmailHtmlViewer;
